import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ChatGptContainerComponent } from '../chat-gpt-container/chat-gpt-container.component';
import { OcrPlusTxtComponent } from '../ocr-plus-txt/ocr-plus-txt.component';

@Component({
  selector: 'app-ocr-plus',
  templateUrl: './ocr-plus.component.html',
  styleUrls: ['./ocr-plus.component.css'],
})
export class OcrPlusComponent {
  @ViewChild('ocrPlusTxt')
  ocrPlusTxtRf: ElementRef<OcrPlusTxtComponent>;
  @ViewChild('gptRf') gptRf: ElementRef<ChatGptContainerComponent>;


  showBtn = 'none';
  currentItemType: any;
  currentItem: any;
  ocrPlusTxt: OcrPlusTxtComponent;
  itemOver: any;

  jsonData: any;
  tabIndex: number;

  gptContainer: ChatGptContainerComponent;
  option: any;

  ngAfterViewInit() {

    this.ocrPlusTxt = this
      .ocrPlusTxtRf as unknown as OcrPlusTxtComponent;
    this.gptContainer = this.gptRf as unknown as ChatGptContainerComponent;


    const tabIndex = localStorage.getItem('tabIndex');
    if (tabIndex) this.tabIndex = parseInt(tabIndex);
    else this.tabIndex = 0;
  }


  get tree() {
    if (!this.jsonData) {
      return [];
    }
    return this.jsonData.tree;
  }


  setItemOverHandler(itemOver: (key: any, value: any) => void) {
    this.itemOver = itemOver;
  }
  setOcrPlusData(jsonData: any, option: any = {isUid: false}) {
    this.option = option;
    this.jsonData = jsonData;
  }

  isRTL() {
    if (this.jsonData && this.jsonData.isRTL)
      return true
    return false
  }



  onTabChanged(event: MatTabChangeEvent) {
    console.log('Tab changed, new index: ' + event.index);
    this.tabIndex = event.index;
    localStorage.setItem('tabIndex', event.index.toString());
  }

  restart() {
    // this.unchooseTr();
    this.jsonData = null;
    if (this.gptContainer)
      this.gptContainer.restart();
  }

  mouseDown(x: number, y: number) {
    // console.log('mouseDown', x, y);
    this.ocrPlusTxt.mouseDown(x, y);
  }
}
